module.exports = __webpack_public_path__ + "./images/65e21c79eb3d17aa8ecc9af8d4e47e30.webp";